import FeaturedProject from "~/components/landingPage/FeaturedProject"
import HeroSection from "~/components/landingPage/HeroSection"
import HowItWork from "~/components/landingPage/HowItWork"
import KeySectors from "~/components/landingPage/KeySectors"
import PartnerSector from "~/components/landingPage/PartnerSector"
import ReadyToJoin from "~/components/landingPage/ReadyToJoin"
import WhyRegister from "~/components/landingPage/WhyRegister"

export default function pageIndex() {
  return (
    <div className="space-y-10">
      <HeroSection />
      <KeySectors />
      <HowItWork />
      <WhyRegister />
      <ReadyToJoin />
      <PartnerSector/>
    </div>
  )
}
